import { exportTestInstance, recordTestInstance } from '../axios';

const get = (pagination: any, sortOrder: any, customerId: any, locationId: any ) =>
  recordTestInstance.post('/tire-optix-queue', { pagination, sortOrder, customerId, locationId });

const getFiltersData = (customerId: any, locationId: any) =>
  recordTestInstance.post('/tire-optix-queue/filter-data', { customerId, locationId });

const getFilters = (pagination: any, sortOrder: any, customerId: any, locationId: any, filters: any = { searchString: null } ) =>
  recordTestInstance.post('/tire-optix-queue/filter', { pagination, sortOrder, customerId, locationId, filters } );

const saveComments = (comments: any, customerId: any, locationId: any, glsSurveyId: any, tireOptixSurveyId: any) =>
  recordTestInstance.post('/tire-optix-queue/save-comments', { comments, customerId, locationId, glsSurveyId, tireOptixSurveyId });

const printExcel = (input: any) =>
  exportTestInstance.post('/tire-optix-queue/export-excel', { input }, {
    headers:
    {
      'Content-Disposition': 'attachment; filename=template.xlsx',
      'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    },
    responseType: 'arraybuffer',
  });

const printPdf = (input: any) =>
  exportTestInstance.post('/tire-optix-queue/export-pdf', { input }, {
    headers:
    {
      'Content-Disposition': 'attachment; filename=template.pdf',
      'Content-Type': 'application/pdf',
    },
    responseType: 'arraybuffer',
  });

export default {
  get,
  getFiltersData,
  getFilters,
  printExcel,
  printPdf,
  saveComments,
};